import { memo } from 'react';
import type { Language } from '@codedrill/shared';

interface WelcomeViewProps {
  onSelect: (lang: Language) => void;
}

const QUICKSTART: { value: Language; label: string; description: string; sample: string }[] = [
  {
    value: 'c',
    label: 'C',
    description: 'Pointers, memory, systems fundamentals',
    sample: 'int *ptr = malloc(sizeof(int));',
  },
  {
    value: 'cpp',
    label: 'C++',
    description: 'Classes, templates, modern C++',
    sample: 'std::vector<int> v = {1, 2, 3};',
  },
  {
    value: 'python',
    label: 'Python',
    description: 'Clean syntax, scripting, data',
    sample: 'def greet(name: str) -> str:',
  },
];

const WelcomeView = memo(function WelcomeView({ onSelect }: WelcomeViewProps) {
  return (
    <div className="welcome-view">
      <div className="welcome-header">
        <p className="welcome-title">select a language to begin</p>
        <p className="welcome-sub">
          practice typing real code — build speed and muscle memory
        </p>
      </div>

      <div className="welcome-cards">
        {QUICKSTART.map((lang) => (
          <button
            key={lang.value}
            className="welcome-card"
            onClick={() => onSelect(lang.value)}
          >
            <span className="welcome-card-label">{lang.label}</span>
            <span className="welcome-card-desc">{lang.description}</span>
            <span className="welcome-card-sample">{lang.sample}</span>
          </button>
        ))}
      </div>

      <p className="welcome-hint">
        pick any language from the sidebar, or click a card above to jump in
      </p>
    </div>
  );
});

export default WelcomeView;
